import { Card, List, Typography, Empty, Button, Divider, Space, Modal, message, Tag } from "antd";
import { PrinterOutlined, EyeOutlined } from "@ant-design/icons";
import { useState } from "react";
import Invoice from "../../components/invoices/View";

const { Text } = Typography;

const CARD_STYLE = {
  borderRadius: 16,
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  height: "85vh",
  width: "95%",
  margin: "20px auto",
  display: "flex",
  flexDirection: "column",
};

const CompletedOrder = ({ ListOfCompletedBills, onPrint }) => {
  const [selectedBill, setSelectedBill] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePrint = (bill) => {
    if (onPrint) onPrint(bill);
    else message.info(`Printing bill ${bill.Bill_ID}`);
  };

  const handleViewDetail = (bill) => {
    setSelectedBill(bill);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedBill(null);
    setIsModalOpen(false);
  };

  return (
    <Card style={CARD_STYLE}>
      {(ListOfCompletedBills ?? []).length === 0 ? (
        <Empty description="No completed bills" />
      ) : (
        <div>
          <List
            bordered
            dataSource={ListOfCompletedBills ?? []}
            style={{ maxHeight: "520px", overflowY: "auto" }}
            renderItem={(bill) => (
              <List.Item
                actions={[
                  <Space align="center" key="actions">
                    <Button
                      type="default"
                      icon={<EyeOutlined />}
                      onClick={() => handleViewDetail(bill)}
                    >
                      View Detail
                    </Button>
                    <Button
                      type="primary"
                      icon={<PrinterOutlined />}
                      onClick={() => handlePrint(bill)}
                    >
                      Print
                    </Button>
                  </Space>,
                ]}
              >
                <div>
                  <Text strong style={{ display: "inline-block", width: 100 }}>ID: {bill.Bill_ID} </Text>
                  <Tag color="pink" strong style={{ display: "inline-block", width: 90, marginRight: "20px" }} >Total: ${(bill.Total ?? 0).toFixed(2)} </Tag>
                  <Tag color={bill.paymentMethod === "Cash" ? "green" : "blue"} style={{ marginRight: "20px" }} ><Text strong>paid:</Text> {bill.paymentMethod}</Tag>
                  <Text strong style={{ display: "inline-block", width: 150 }}>Cashier: {bill.Cashier_Name}</Text>
                  <Text strong style={{ display: "inline-block", width: 150 }}>Date: {bill.Date}</Text>
                </div>
              </List.Item>
            )}
          />
          <Divider />
          <Text strong>
            🧾 Total Revenue: $
            {((ListOfCompletedBills ?? []).reduce((sum, b) => sum + (b.Total ?? 0), 0)).toFixed(2)}
          </Text>
        </div>
      )}

      {/* Modal for Invoice */}
      <Modal
        open={isModalOpen}
        onCancel={handleCloseModal}
        footer={null}
        width={500}
        centered
        title={<p style={{ fontSize: "20px" }}>Invoice Detail</p>}
      >
        {selectedBill && <Invoice invoices={selectedBill} />}
      </Modal>
    </Card>
  );
};

export default CompletedOrder;
